export interface CustomView {
    uid: string;
    name: null | string;
    columns: string[];
    default_view: boolean;
    parent?: string;
    is_current: boolean;
}
